import { Button } from "@/components/ui/Button"
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog"

interface ConfirmDialogProps {
  open: boolean
  title?: string
  message: string
  onClose: () => void
}

export function ConfirmDialog({
  open,
  title,
  message,
  onClose,
}: ConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen: boolean) => !isOpen && onClose()}
    >
      <DialogContent className="tw-max-w-lg tw-font-sansAlt">
        <DialogHeader>
          <DialogTitle>{title || "Success"}</DialogTitle>
        </DialogHeader>
        <div className="tw-py-4">
          <p className="tw-text-sm tw-text-gray-600">{message}</p>
        </div>
        <DialogFooter>
          <Button onClick={onClose}>OK</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
